import React from 'react'
import styles from './ShowcaseCard.scss'
import {photoLarge} from 'lib/urlHelpers'
import {Icon} from 'common/LegacyIcon'
import {Link} from 'react-router'

// hacky because one-off
const isBlockWithImage = (block) => block.type === 'atomic' && block.data && block.data.type === 'gallery' && block.data.imageIds && block.data.imageIds[0]
export const coverImage = (reportContent) => {
  const firstBlockWithImage = reportContent.blocks.find(isBlockWithImage)
  if (!firstBlockWithImage) { return null }
  return firstBlockWithImage.data.imageIds[0]
}

export const ShowcaseCard = ({report}) => (
  <Link to={`/ride_reports/${report.slug}`} className={styles.ShowcaseCard} style={{backgroundImage: `url(${photoLarge(coverImage(report.reportContent))})`}}>
    <div className={styles.content}>
      <Link to={`/ride_reports/${report.slug}`}><h2 className={styles.title}>{report.title}</h2></Link>
      <div className={styles.authorship}>by {report.user.name}</div>
      <span className={styles.readLink}>Read More <Icon i='rightChevron' size={12} /></span>
    </div>
  </Link>
)

export const ShowcaseCardContainer = (props) => <div className={styles.container} {...props} />
